(function () {
    "use strict";

    Controllers.ClientPortalSendLinkController = class ClientPortalSendLinkController extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor($scope, $injector, _, $q, $modalInstance, ModalService, $translate, AnalyticsService, UsersManager, CompaniesManager, PopupMessageService,
                    UserService, $timeout, workspaceClients, clientPortalUrl, DeviceService, ContactsManager, ModelFactory) {
            super($scope, $injector);
            this.__objectType = 'ClientPortalSendLinkController';
            this.$q = $q;
            this._ = _;
            this.$timeout = $timeout;
            this.$modalInstance = $modalInstance;
            this.ModalService = ModalService;
            this.$translate = $translate;
            this.currentUser = UsersManager.getCurrUser();
            this.UserService = UserService;
            this.UsersManager = UsersManager;
            this.DeviceService = DeviceService;
            this.ContactsManager = ContactsManager;
            this.PopupMessageService = PopupMessageService;
            this.ModelFactory = ModelFactory;
            this.contacts = ModelFactory.newContactsCollection();
            this.AnalyticsService = AnalyticsService;
            this.CompaniesManager = CompaniesManager;

            this.workspaceClients = workspaceClients || false;
            this.recipients = [];

            if (!this.workspaceClients) {
                this._initSettingsFlow();
            } else {
                this.clientPortalUrl = clientPortalUrl || '';
            }

            this.source = !this.workspaceClients ? 'settings' : 'workspace';
        };

        onDismiss() {
            this.$modalInstance.dismiss();
        }

        onClose() {
            this.$modalInstance.close();
        }

        _initSettingsFlow(){
            this._focusInputOnLoad();
        }

        _filterData(contacts){
           return this._.map(contacts, (contact) => {
             return { name: contact.user.full_name, text: contact.user.email};
           });
        }

        _focusInputOnLoad(){
            this.$timeout(() => angular.element('.tags').find('input').select());
        }

        onTagAdded($tag) {
            this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.add_recipient_client_portal_link, {
                source: "client portal send link modal"
            });
        }

        onSelectedWorkspaceClient(client){
            var idx = this.recipients.indexOf(client);

            if (idx > -1) {
                this.recipients.splice(idx, 1);
            } else {
                this.recipients.push(client);
            }
        }

        _clientPortalEmail(){
            const body = this.$translate.instant('CLIENT_PORTAL.SEND_LINK._EMAIL_BODY_');
            const link = `<a target="_blank" href="clientPortalLinkPlaceholder">${this.$translate.instant('CLIENT_PORTAL.SEND_LINK._CLIENT_PORTAL_')}</a>`;

            return {
                subject: 'Your Client Portal',
                html_body: `</br>${body}</br></br>${link}</br></br>Warmly,</br>${this.currentUser.full_name}`
            };
        }

        _cleanData(contacts){
            return this._.map(contacts, (contact) => {
                return { full_name: contact.name, email: contact.text};
            });
        }

        fetchSuggestions($query) {
            var defer = this.$q.defer();

            this.ContactsManager.getUserContacts(this.contacts, this.currentUser, 1, {has_project: true, text: $query}, 20)
                .then((resp) => {
                    let result = this._filterData(resp.data.data);
                    defer.resolve(result);
                })
                .catch((resp) => {
                    defer.resolve([]);
                });

            return defer.promise;
        }


        previewClientPortalSendLinkEmail() {
            this.sendingLink = true;
            const email = this._clientPortalEmail();
            const config = { showFromLine: true,
                showBccMyselfCheckbox: false,
                editorType: "client portal link" };
            let recipients = this.workspaceClients ? this.recipients : this._cleanData(this.recipients);


            var options  = {
                users: recipients,
                subject: email.subject,
                body: email.html_body,
                generalFiles: email.file_attachments,
                imageFiles: email.image_attachments,
                senderFunction: this._sendLink.bind(this),
                config: config,
                showScheduleOption: false
            };

            this.ModalService.openEmailEditorModal(options)
                .then(() => {
                    this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.send_client_portal_link, {source: this.source});
                })
                .catch((res) => {
                    if (res && res.data && res.data.error_message) {
                        this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, res.data.error_message);
                    }
                })
                .finally(() => {
                    this.$modalInstance.close();
                });



        }

        _sendLink(user, subject, body) {
            return this.CompaniesManager.sendClientPortalLink(user, subject, body);
        }

    };


}());




